export enum ScheduleFrequency {
    Once = 'once',
    Hourly = 'hourly',
    Daily = 'daily',
    Weekly = 'weekly',
    Monthly = 'monthly',
}
